var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.89 9.544C17.196 6.237 13.842 4 10 4 6.16 4 2.803 6.24 1.11 9.544a1.01 1.01 0 000 .912C2.804 13.763 6.158 16 10 16c3.84 0 7.197-2.24 8.89-5.544a1.01 1.01 0 000-.912zM10 14.5a4.5 4.5 0 114.5-4.5 4.497 4.497 0 01-4.5 4.5zM10 7a2.979 2.979 0 00-.791.118 1.495 1.495 0 01-2.09 2.091A2.993 2.993 0 1010 7.001z"
  })));
}
export default SvgEye;